import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import MessageBox from '../../../components/CommonComponents/MessageBox';
import { liveOrderDefaultURL } from '../../../components/CommonApis/CommonLiveOrderApi';
import Response_Processing from '../../../layout/Others/Response_Processing';
import { FaEllipsisVertical } from 'react-icons/fa6';
import NoRecordTable from '../../../components/CommonComponents/NoRecordTable';
import { Link } from 'react-router-dom';
import AdminCustomButton from '../../../components/CommonComponents/AdminCustomButton';
import { getItemToken } from '../../../Utils/localStorageUtils';
import AdminSelectOptionModal from '../../../components/CommonComponents/AdminSelectOptionModal';
import AdminSwitch from '../../../components/CommonComponents/AdminSwitch';
import { IconEditFigma } from '../../../Assets/MyIcons';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';

const LiveSettings = () => {
   const [apiData, setApiData] = useState([]);
   const [enableWebSettings, setEnableWebSettings] = useState([]);
   const [enableMobileSettings, setEnableMobileSettings] = useState([]);
   const [enableTvSettings, setEnableTvSettings] = useState([]);
   const [enableSamsungSettings, setEnableSamsungSettings] = useState([]);
   const [enableLgSettings, setEnableLgSettings] = useState([]);

   const [showOverlay, setShowOverlay] = useState(false);
   const [loading, setLoading] = useState(false);
   const [withOutRefresh, setWithOutRefresh] = useState(false);

   const headerToken = getItemToken('access_token');

   const fetchData = async () => {
      try {
         setLoading(true)
         const response = await axios.get(`${liveOrderDefaultURL?.listApi}`, { headers: headerToken })
         const result = response?.data?.Web_Livestream_HomePage_Order;
         if (response?.data?.status) {
            setApiData(result)
            setLoading(false)
         }
         else {
            setLoading(false)
         }
      }
      catch (error) {
         const errMessage = error?.response?.data?.message
         console.error(errMessage)
      }
   }

   const enableWebData = async () => {
      try {
         const response = await axios.get(`${liveOrderDefaultURL?.enableWebSettingURL}`, {
            headers: headerToken
         });
         const result = response?.data;
         if (result?.status) {
            setEnableWebSettings(result?.Web_Livestream_HomePage_Order);
            setLoading(false);
         } else {
            setLoading(false);
            toast.error(result?.message);
         }
      } catch (error) {
         const errMsg = error?.response?.message;
         console.error(errMsg);
      }
   }
   const enableMobileData = async () => {
      try {
         const response = await axios.get(`${liveOrderDefaultURL?.enableMobileSettingURL}`, {
            headers: headerToken
         });
         const result = response?.data;
         if (result?.status) {
            setEnableMobileSettings(result?.Mobile_Livestream_HomePage_Order);
            setLoading(false);
         } else {
            setLoading(false);
            toast.error(result?.message);
         }
      } catch (error) {
         const errMsg = error?.response?.message;
         console.error(errMsg);
      }
   }
   const enableTVData = async () => {
      try {
         const response = await axios.get(`${liveOrderDefaultURL?.enableTvSettingURL}`, { headers: headerToken });
         const result = response?.data;
         if (result?.status) {
            setEnableTvSettings(result?.TV_Livestream_HomePage_Order);
            setLoading(false);
         } else {
            setLoading(false);
            toast.error(result?.message);
         }
      } catch (error) {
         const errMsg = error?.response?.message;
         console.error(errMsg);
      }
   }

   const enableSamsungData = async () => {
      try {
         const response = await axios.get(`${liveOrderDefaultURL?.enableSamsungSettingURL}`, { headers: headerToken });
         const result = response?.data;
         if (result?.status) {
            setEnableSamsungSettings(result?.Samsung_Livestream_HomePage_Order);
            setLoading(false);
         } else {
            setLoading(false);
            toast.error(result?.message);
         }
      } catch (error) { console.error(error?.response?.message); }
   }

   const enableLgData = async () => {
      try {
         const response = await axios.get(`${liveOrderDefaultURL?.enableLgSettingURL}`, { headers: headerToken });
         const result = response?.data;
         if (result?.status) {
            setEnableLgSettings(result?.LG_Livestream_HomePage_Order);
            setLoading(false);
         } else {
            setLoading(false);
            toast.error(result?.message);
         }
      } catch (error) { console.error(error?.response?.message); }
   }

   const handleDragEnd = (result) => {
      if (!result.destination) return;
      const items = Array.from(apiData);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);
      setApiData(items);
      saveShuffleOrder(items);
   }

   const saveShuffleOrder = async (updatedItems) => {
      setShowOverlay(true);
      if (!updatedItems || updatedItems.length === 0) {
         console.error("Menu items are empty");
      }
      const position = updatedItems.map((menuItem) => menuItem?.id);
      const ids = updatedItems?.map((_, index) => index + 1);
      const requestData = {
         id: position,
         position: ids
      };

      try {
         const response = await axios.post(`${liveOrderDefaultURL?.orderApi}`, requestData, {
            headers: headerToken
         });
         const result = response?.data;
         if (result?.status) {
            setShowOverlay(false);
            toast.success(result?.message);
            setWithOutRefresh(!withOutRefresh);
         } else {
            setShowOverlay(false);
            toast.error(result?.message);
         }
      } catch (error) {
         const errMsg = error?.response?.data?.message;
         toast.error(errMsg);
         setShowOverlay(false);
      }
   };

   const handleToggleWebSettings = async (name, value) => {
      const updatedSetting = enableWebSettings.map((item) => item?.name === name ? { ...item, Web_HomePage_status: value ? 0 : 1 } : item);
      setEnableWebSettings(updatedSetting)
   }
   const handleToogleMobileSettings = async (name, value) => {
      const updatedSetting = enableMobileSettings.map((item) => item?.name === name ? { ...item, Mobile_Homesetting_status: value ? 0 : 1 } : item);
      setEnableMobileSettings(updatedSetting);
   }
   const handleToogleTVSettings = async (name, value) => {
      const updatedSetting = enableTvSettings.map((item) => item?.name === name ? { ...item, TV_HomePage_status: value ? 0 : 1 } : item);
      setEnableTvSettings(updatedSetting);
   }
   const handleToogleSamsungSettings = async (name, value) => {
      const updatedSetting = enableSamsungSettings.map((item) => item?.name === name ? { ...item, Samsung_HomePage_status: value ? 0 : 1 } : item);
      setEnableSamsungSettings(updatedSetting);
   }
   const handleToogleLgSettings = async (name, value) => {
      const updatedSetting = enableLgSettings.map((item) => item?.name === name ? { ...item, LG_HomePage_status: value ? 0 : 1 } : item);
      setEnableLgSettings(updatedSetting);
   }

   const updateWebSettings = async () => {
      setShowOverlay(true);
      try {
         const formData = {};
         enableWebSettings.forEach((item) => {
            const status = Number.isNaN(parseInt(item?.Web_HomePage_status)) ? 0 : parseInt(item?.Web_HomePage_status, 10);
            formData[item?.name] = status;
         });
         const response = await axios.post(`${liveOrderDefaultURL?.updateWebSettingURL}`, formData, {
            headers: headerToken
         });
         const result = response.data;
         if (result?.status) {
            toast.success(result?.message);
            setShowOverlay(false);
            setWithOutRefresh(!withOutRefresh)
         }
         else {
            toast.error(result?.message);
            setShowOverlay(false);
         }

      } catch (error) {
         const errMsg = error?.response?.data?.message;
         toast.error(errMsg);
         setShowOverlay(false);
      }
   }
   const updatedMobileSettings = async () => {
      setShowOverlay(true);
      try {
         const formData = {};
         enableMobileSettings.forEach((item) => {
            const status = Number.isNaN(parseInt(item?.Mobile_Homesetting_status)) ? 0 : parseInt(item?.Mobile_Homesetting_status, 10);
            formData[item?.name] = status;
         });
         const response = await axios.post(`${liveOrderDefaultURL?.updateMobileSettingURL}`, formData, {
            headers: headerToken
         });
         const result = response.data;
         if (result?.status) {
            toast.success(result?.message);
            setShowOverlay(false);
            setWithOutRefresh(!withOutRefresh)
         }
         else {
            toast.error(result?.message);
            setShowOverlay(false);
         }

      } catch (error) {
         const errMsg = error?.response?.data?.message;
         toast.error(errMsg);
         setShowOverlay(false);
      }
   }
   const updateTVSettings = async () => {
      setShowOverlay(true);
      try {
         const formData = {};
         enableTvSettings.forEach((item) => {
            const status = Number.isNaN(parseInt(item?.TV_HomePage_status)) ? 0 : parseInt(item?.TV_HomePage_status, 10);
            formData[item?.name] = status;
         });
         const response = await axios.post(`${liveOrderDefaultURL?.updateTvSettingURL}`, formData, { headers: headerToken });
         const result = response.data;
         if (result?.status) { toast.success(result?.message); setShowOverlay(false); setWithOutRefresh(!withOutRefresh) }
         else { toast.error(result?.message); setShowOverlay(false); }
      } catch (error) { toast.error(error?.response?.data?.message); setShowOverlay(false); }
   }

   const updateSamsungSettings = async () => {
      setShowOverlay(true);
      try {
         const formData = {};
         enableSamsungSettings.forEach((item) => {
            const status = Number.isNaN(parseInt(item?.Samsung_HomePage_status)) ? 0 : parseInt(item?.Samsung_HomePage_status, 10);
            formData[item?.name] = status;
         });
         const response = await axios.post(`${liveOrderDefaultURL?.updateSamsungSettingURL}`, formData, { headers: headerToken });
         const result = response.data;
         if (result?.status) { toast.success(result?.message); setShowOverlay(false); setWithOutRefresh(!withOutRefresh) }
         else { toast.error(result?.message); setShowOverlay(false); }
      } catch (error) { toast.error(error?.response?.data?.message); setShowOverlay(false); }
   }

   const updateLgSettings = async () => {
      setShowOverlay(true);
      try {
         const formData = {};
         enableLgSettings.forEach((item) => {
            const status = Number.isNaN(parseInt(item?.LG_HomePage_status)) ? 0 : parseInt(item?.LG_HomePage_status, 10);
            formData[item?.name] = status;
         });
         const response = await axios.post(`${liveOrderDefaultURL?.updateLgSettingURL}`, formData, { headers: headerToken });
         const result = response.data;
         if (result?.status) { toast.success(result?.message); setShowOverlay(false); setWithOutRefresh(!withOutRefresh) }
         else { toast.error(result?.message); setShowOverlay(false); }
      } catch (error) { toast.error(error?.response?.data?.message); setShowOverlay(false); }
   }

   useEffect(() => {
      enableWebData();
      enableMobileData();
      enableTVData();
      enableSamsungData();
      enableLgData();
      fetchData();
   }, [withOutRefresh]);



   return (
      <>
         <div>
            {showOverlay && <Response_Processing />}
         </div>
         <div className='m-0 p-0'>
            <div className=''>
               <section className='section container-fluid pt-3'>
                  <div className='p-0'>
                     <div id='webhomesettings'>
                        <div className='iq-card home_mobile'>
                           <nav>
                              <div className='nav nav-tabs' id='nav-tab' role='tablist'>
                                 <button className='nav-link active' id='nav-home-tab' data-bs-toggle='tab' data-bs-target='#nav-home' type='button' role='tab' aria-controls='nav-home' aria-selected='true'><h6>Live - Web</h6></button>
                                 <button className='nav-link' id='nav-profile-tab' data-bs-toggle='tab' data-bs-target='#nav-profile' type='button' role='tab' aria-controls='nav-profile' aria-selected='false'><h6>Live - Mobile</h6></button>
                                 <button className='nav-link' id='pills-contact-tab' data-bs-toggle='tab' data-bs-target='#pills-contact' type='button' role='tab' aria-controls='pills-contact' aria-selected='false'><h6>Live - TV</h6></button>
                                 <button className='nav-link' id='nav-samsung-tab' data-bs-toggle='tab' data-bs-target='#nav-samsung' type='button' role='tab' aria-controls='nav-samsung' aria-selected='false'><h6>Live - Samsung</h6></button>
                                 <button className='nav-link' id='nav-lg-tab' data-bs-toggle='tab' data-bs-target='#nav-lg' type='button' role='tab' aria-controls='nav-lg' aria-selected='false'><h6>Live - LG</h6></button>
                              </div>
                           </nav>

                           <div className='tab-content' id='nav-tabContent'>
                              <div className='tab-pane fade show active' id='nav-home' role='tabpanel' aria-labelledby='nav-home-tab'>
                                 <div className='panel-body mt-3'>
                                    <h6>Web LiveStream HomePage Menu Settings</h6> <hr />

                                    <div className="row align-items-center theme-bg-color rounded-2 p-3">
                                       {loading ? <NoRecordTable loader={true} /> :
                                          <>
                                             {enableWebSettings?.map((item) => {
                                                return <div className={`col-12 col-md-6 category-order-title p-1 mb-2`}>
                                                   <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                                      <MessageLabel text={item?.header_name?.length > 30 ? `${item.header_name.slice(0, 30)}...` : item?.header_name} classname="theme-text-color" noMargin />
                                                      <AdminSwitch name={item?.name} checked={item?.Web_HomePage_status} onChange={() => handleToggleWebSettings(item?.name, item?.Web_HomePage_status)} />
                                                   </div>
                                                </div>
                                             })}
                                             <div className='col-12 text-end mt-3'>
                                                <AdminCustomButton saveMethod={updateWebSettings} saveText="Save Web Settings" />
                                             </div>
                                          </>}
                                    </div>


                                 </div>
                              </div>

                              <div className='tab-pane fade' id='nav-profile' role='tabpanel' aria-labelledby='nav-profile-tab'>
                                 <div className='panel-body mt-3'>
                                    <h6>Mobile LiveStream HomePage Menu Settings</h6> <hr />
                                    <div className="row align-items-center theme-bg-color rounded-2 p-3">
                                       {loading ? <NoRecordTable loader={true} /> :
                                          <>
                                             {enableMobileSettings?.map((item) => {
                                                return <div className={`col-12 col-md-6 category-order-title p-1 mb-2 `}>
                                                   <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                                      <MessageLabel text={item?.header_name?.length > 30 ? `${item.header_name.slice(0, 30)}...` : item?.header_name} classname="theme-text-color" noMargin />
                                                      <AdminSwitch name={item?.name} checked={item?.Mobile_Homesetting_status} onChange={() => handleToogleMobileSettings(item?.name, item?.Mobile_Homesetting_status)} />
                                                   </div>
                                                </div>
                                             })}
                                             <div className='col-12 text-end mt-3'>
                                                <AdminCustomButton saveMethod={updatedMobileSettings} saveText="Save Mobile Settings" />
                                             </div>
                                          </>}
                                    </div>

                                 </div>
                              </div>

                              <div className='tab-pane fade' id='pills-contact' role='tabpanel' aria-labelledby='pills-contact-tab'>
                                 <div className='panel-body mt-3'>
                                    <h6>TV LiveStream HomePage Menu Settings</h6> <hr />
                                    <div className="row align-items-center theme-bg-color rounded-2 p-3">
                                       {loading ? <NoRecordTable loader={true} /> :
                                          <>
                                             {enableTvSettings?.map((item) => {
                                                return <div className={`col-12 col-md-6 category-order-title p-1 mb-2 `}>
                                                   <div className="input-group color-picker d-flex align-items-center justify-content-between">
                                                      <MessageLabel text={item?.header_name?.length > 30 ? `${item.header_name.slice(0, 30)}...` : item?.header_name} classname="theme-text-color" noMargin />
                                                      <AdminSwitch name={item?.name} checked={item?.TV_HomePage_status} onChange={() => handleToogleTVSettings(item?.name, item?.TV_HomePage_status)} />
                                                   </div>
                                                </div>
                                             })}
                                             <div className='col-12 text-end mt-3'>
                                                <AdminCustomButton saveMethod={updateTVSettings} saveText="Save TV Settings" />
                                             </div>
                                          </>}
                                    </div>

                                 </div>
                              </div>
                           </div>
                        </div>
                        {/* Order List */}
                        <h4 className="admin-title mb-4 theme-text-color text-md-start">
                           <MessageBox text="Order LiveStream" classname="theme-text-color" />
                        </h4>
                        <div className="bootstrapTable theme-bg-color p-3 rounded-2">
                           <div className="row m-0 theme-border-bottom-secondary pb-3">
                              <div className="col-2 "> <label className="theme-text-color fw-bold fs-6"># </label> </div>
                              <div className="col-5 "><label className="theme-text-color fw-bold fs-6">Name</label></div>
                              <div className="col-5 "><label className="theme-text-color fw-bold fs-6"> Actions </label> </div>
                           </div>
                           <DragDropContext onDragEnd={handleDragEnd}>
                              <Droppable droppableId="menu-items" className="theme-bg-color"   >
                                 {(provided) => (
                                    <ul  {...provided.droppableProps} ref={provided.innerRef} className="pb-5 px-0 theme-bg-color list-unstyled m-0 p-0">
                                       {loading ? <NoRecordTable result={apiData?.length} loader={true} /> :
                                          apiData?.map((item, index) => (
                                             <Draggable key={item?.id.toString()} draggableId={item?.id.toString()} index={index} >
                                                {(provided) => (
                                                   <li ref={provided.innerRef} {...provided.draggableProps}  {...provided.dragHandleProps} className={` theme-bg-color theme-text-color  orderborder ${item.order} index ${index + 1} w-100 theme-border-bottom-secondary`} >
                                                      <div className="row m-0 p-0 align-items-center">
                                                         <div className="col-2  category-order-title">
                                                            <div className='d-flex position-relative '>
                                                               <p className="theme-text-color mb-3 admin-input-title d-block position-relative"> {item?.order_id} </p>
                                                            </div >
                                                         </div>
                                                         <div className="col-5  category-order-title">
                                                            <MessageLabel text={item?.header_name?.length > 30 ? `${item.header_name.slice(0, 30)}...` : item?.header_name} classname="theme-text-color" noMargin />
                                                         </div>
                                                         <div className="col-5  category-order-title">
                                                            <div className="editdropdown">
                                                               <span className="editdropdown-button">
                                                                  <span>
                                                                     <FaEllipsisVertical className="theme-text-color" />
                                                                  </span>
                                                               </span>
                                                               <div className="editdropdown-menu theme-bg-color">
                                                                  <Link to={`/edit-live-order/${item?.id}`} className="theme-text-color  theme-bg-color">
                                                                     <span>
                                                                        <IconEditFigma styled={{ width: "20px", height: "20px" }} />
                                                                        <MessageBox text="Edit" classname='ms-2 theme-text-color'></MessageBox>
                                                                     </span>
                                                                  </Link>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </li>
                                                )}
                                             </Draggable>
                                          ))}
                                    </ul>
                                 )}
                              </Droppable>
                           </DragDropContext>
                        </div>
                     </div>
                  </div>
               </section>
            </div>
         </div>
      </>
   );
}
export default LiveSettings;